import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ChevronLink } from '@bibliocommons/base-links';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import Heading from 'app/components/shared/Heading';
import { ugcSummaryShape } from 'app/shapes/bibPage';
import ContentNoticesSummary from './ContentNoticesSummary';

import './ContentNotices.scss';

export default function ContentNotices({ summary, catalogBib }) {
  const total = summary?.getIn(['contentAdvisories', 'total']) ?? 0;

  const renderContentNoticesLink = () => (
    <ChevronLink
      className="all-content-notices"
      dataKey="all-content-notices"
      href={`/v2/record/${catalogBib.get('metadataId')}/contentnotices`}
    >
      <FormattedMessage id="view_all_content_notices" values={{ count: total }} />
    </ChevronLink>
  );

  return total ? (
    <div className="cp-content-notices" data-key="content-notices">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="ugc_content_advisories" />
      </Heading>
      <ContentNoticesSummary summary={summary} />
      {renderContentNoticesLink()}
    </div>
  ) : null;
}

ContentNotices.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  summary: ugcSummaryShape
};
